export default {
  format: {
    date: 'M/d/yyyy',
    time: 'p',
    dateTime: '$t(format:date) $t(format:time)',
    longDate: 'MMM d',
    longDateTime: "MMMM d 'at' p",
    fullDate: 'MMM d, y',
    fullDateTime: "MMMM d, y 'at' p",
  },

  translation: {
    common: {
      account: 'Account',
      actions: 'Actions',
      addAttachment_title: 'Add Attachment',
      addComment: 'Add comment',
      addManager_title: 'Add Manager',
      addMember_title: 'Add Member',
      addUser_title: 'Add User',
      administrator: 'Administrator',
      all: 'All',
      allChangesWillBeAutomaticallySavedAfterConnectionRestored:
        'All changes will be automatically saved<br />after connection restored.',
      areYouSureYouWantToDeleteThisAttachment: 'Are you sure you want to delete this attachment?',
      areYouSureYouWantToDeleteThisBoard: 'Are you sure you want to delete this board?',
      areYouSureYouWantToDeleteThisCard: 'Are you sure you want to delete this card?',
      areYouSureYouWantToDeleteThisComment: 'Are you sure you want to delete this comment?',
      areYouSureYouWantToDeleteThisFolder: 'Are you sure you want to delete this folder?',
      areYouSureYouWantToDeleteThisLabel: 'Are you sure you want to delete this label?',
      areYouSureYouWantToDeleteThisList: 'Are you sure you want to delete this list?',
      areYouSureYouWantToDeleteThisProject: 'Are you sure you want to delete this project?',
      areYouSureYouWantToDeleteThisTask: 'Are you sure you want to delete this task?',
      areYouSureYouWantToDeleteThisUser: 'Are you sure you want to delete this user?',
      areYouSureYouWantToLeaveBoard: 'Are you sure you want to leave the board?',
      areYouSureYouWantToLeaveProject: 'Are you sure you want to leave the project?',
      areYouSureYouWantToRemoveThisManagerFromProject:
        'Are you sure you want to remove this manager from the project?',
      areYouSureYouWantToRemoveThisMemberFromBoard:
        'Are you sure you want to remove this member from the board?',
      attachment: 'Attachment',
      attachments: 'Attachments',
      authentication: 'Authentication',
      background: 'Background',
      board: 'Board',
      boardName: 'Board name',
      boardNotFound_title: 'Board Not Found',
      boardPermissions_title: 'Board permissions',
      canComment: 'Can comment',
      canEditContentOfBoard: 'Can edit the content of the board.',
      canOnlyViewBoard: 'Can only view the board.',
      cardActions_title: 'Card Actions',
      cardNotFound_title: 'Card Not Found',
      cardOrActionAreDeleted: 'Card or action are deleted.',
      color: 'Color',
      commenter: 'Commenter',
      commentsAndActivities: 'Comments and activity',
      copy_inline: 'copy',
      createBoard_title: 'Create Board',
      createLabel_title: 'Create Label',
      createNewOneOrSelectExistingOne:
        'Create a new one or select<br />an existing one from the menu.',
      createProject_title: 'Create Project',
      createTextFile_title: 'Create Text File',
      currentPassword: 'Current password',
      dangerZone_title: 'Danger Zone',
      date: 'Date',
      dueDate: 'Due date',
      dueDate_title: 'Due Date',
      deleteAttachment_title: 'Delete Attachment',
      deleteBoard_title: 'Delete Board',
      deleteCard_title: 'Delete Card',
      deleteFolder_title: 'Delete Folder',
      deleteComment_title: 'Delete Comment',
      deleteLabel_title: 'Delete Label',
      deleteList_title: 'Delete List',
      deleteProject_title: 'Delete Project',
      deleteTask_title: 'Delete Task',
      deleteUser_title: 'Delete User',
      description: 'Description',
      detectAutomatically: 'Detect automatically',
      dropFileToUpload: 'Drop file to upload',
      editor: 'Editor',
      editAttachment_title: 'Edit Attachment',
      editAvatar_title: 'Edit Avatar',
      editBoard_title: 'Edit Board',
      editDueDate_title: 'Edit Due Date',
      editEmail_title: 'Edit E-mail',
      editInformation_title: 'Edit Information',
      editLabel_title: 'Edit Label',
      editPassword_title: 'Edit Password',
      editPermissions_title: 'Edit Permissions',
      editProjectManagers: 'Edit project managers',
      editStopwatch_title: 'Edit Stopwatch',
      editUsername_title: 'Edit Username',
      email: 'E-mail',
      emailAlreadyInUse: 'E-mail already in use',
      enterCardTitle: 'Enter card title... [Ctrl+Enter] to auto-open.',
      enterDescription: 'Enter description...',
      enterFilename: 'Enter filename',
      enterListTitle: 'Enter list title...',
      enterTaskDescription: 'Enter task description...',
      feedbackIntroduction:
        'Projects is under active development and your feedback matters! Do not hesitate to share your thoughts with us:',
      filterByLabels_title: 'Filter By Labels',
      filterByMembers_title: 'Filter By Members',
      fromComputer_title: 'From Computer',
      fromTrello: 'From Trello',
      general: 'General',
      heroTitle: 'The shared project management',
      heroSubtitle: 'Manage your tasks in a collaborative way',
      hours: 'Hours',
      importBoard_title: 'Import Board',
      internalBoardWorkspace: 'Internal workspace',
      invalidCurrentPassword: 'Invalid current password',
      labels: 'Labels',
      language: 'Language',
      leaveBoard_title: 'Leave Board',
      leaveProject_title: 'Leave Project',
      linkIsCopied: 'Link is copied',
      list: 'List',
      listActions_title: 'List Actions',
      manager: 'Boards manager',
      managers_title: 'Boards managers inside the project',
      managerActions_title: 'Manager Actions',
      members: 'Members',
      memberActions_title: 'Member Actions',
      minutes: 'Minutes',
      moveCard_title: 'Move Card',
      myAccount: 'My account',
      name: 'Name',
      newestFirst: 'Newest first',
      newEmail: 'New e-mail',
      newPassword: 'New password',
      newUsername: 'New username',
      noConnectionToServer: 'No connection to server',
      noBoards: 'No boards',
      noLabels: 'No labels',
      noLists: 'No lists',
      noMembers: 'No members',
      noProjects: 'No projects',
      notifications: 'Notifications',
      noUnreadNotifications: 'No unread notifications.',
      oldestFirst: 'Oldest first',
      openBoard_title: 'Open Board',
      optional_inline: 'optional',
      organization: 'Organization',
      orChooseTemplateBoard: 'Or choose a template board:',
      owner: 'Owner',
      permissions_title: 'Permissions',
      phone: 'Phone',
      preferences: 'Preferences',
      pressPasteShortcutToAddAttachmentFromClipboard:
        'Tip: press Ctrl-V (Cmd-V on Mac) to add an attachment from the clipboard.',
      project: 'Project',
      projectSettings: 'Project settings',
      projectTitle: 'Project title',
      projectNotFound_title: 'Project Not Found',
      removeManager_title: 'Remove Manager',
      removeMember_title: 'Remove Member',
      searchLabels: 'Search labels...',
      searchMembers: 'Search members...',
      searchUsers: 'Search users...',
      searchCards: 'Search cards...',
      seconds: 'Seconds',
      selectBoard: 'Select board',
      selectList: 'Select list',
      selectPermissions_title: 'Select Permissions',
      selectProject: 'Select project',
      settings: 'Settings',
      setupReady: 'Everything is ready {{userName}}!',
      sharedBoardWorkspace: 'Shared workspace',
      sortList_title: 'Sort List',
      startByCreatingProject: 'You can now <1>Create project</1>',
      stopwatch: 'Stopwatch',
      subscribeToMyOwnCardsByDefault: 'Subscribe to my own cards by default',
      support: 'Support',
      taskActions_title: 'Task Actions',
      tasks: 'Tasks',
      theme: 'Theme',
      themeDark: 'Dark',
      themeLight: 'Light',
      thereIsNoPreviewAvailableForThisAttachment:
        'There is no preview available for this attachment.',
      time: 'Time',
      title: 'Title',
      userActions_title: 'User Actions',
      userAddedThisCardToList: '<0>{{user}}</0> added this card to <1>{{list}}</1>',
      userAssignedMember: '<0>{{user}}</0> assigned <1>{{member}}</1>',
      userAssignedYouToCard: '<0>{{user}}</0> assigned you to <1>{{card}}</1>',
      userAddedAttachmentToCard: '<0>{{user}}</0> added an attachment to <1>{{card}}</1>',
      userAddedAttachmentToThisCard: '<0>{{user}}</0> added an attachment to this card',
      userChangedDueDateOfCard: '<0>{{user}}</0> modified the due date of <1>{{card}}</1>',
      userChangedDueDateOfThisCard: '<0>{{user}}</0> modified the due date of this card',
      userLeftNewCommentToCard: '<0>{{user}}</0> added a comment on <1>{{card}}</1>',
      userMovedCardFromListToList:
        '<0>{{user}}</0> moved <1>{{card}}</1> from <2>{{fromList}}</2> to <3>{{toList}}</3>',
      userMovedThisCardFromListToList:
        '<0>{{user}}</0> moved this card from <1>{{fromList}}</1> to <2>{{toList}}</2>',
      username: 'Username',
      usernameAlreadyInUse: 'Username already in use',
      userProfile: 'User profile',
      users: 'Users',
      version: 'Version',
      viewer: 'Viewer',
      welcomeBack: 'Welcome back {{userName}}!',
      writeComment: 'Write a comment...',
    },

    action: {
      addAnotherCard: 'Add another card',
      addAnotherList: 'Add another list',
      addAnotherTask: 'Add another task',
      addCard: 'Add card',
      addCard_title: 'Add Card',
      addComment: 'Add comment',
      addList: 'Add list',
      addMember: 'Add member',
      addMoreDetailedDescription: 'Add more detailed description',
      addTask: 'Add task',
      addToCard: 'Add to card',
      addUser: 'Add user',
      copyLink_title: 'Copy task link',
      create: 'Create',
      createBoard: 'Create board',
      createFile: 'Create file',
      createLabel: 'Create label',
      createNewLabel: 'Create new label',
      createProject: 'Create project',
      delete: 'Delete',
      deleteAttachment: 'Delete attachment',
      deleteAvatar: 'Delete avatar',
      deleteBoard: 'Delete board',
      deleteCard: 'Delete card',
      deleteCard_title: 'Delete Card',
      deleteComment: 'Delete comment',
      deleteFolder: 'Delete folder',
      deleteImage: 'Delete image',
      deleteLabel: 'Delete label',
      deleteList: 'Delete list',
      deleteList_title: 'Delete List',
      deleteNotifications: 'Dismiss all',
      deleteProject: 'Delete project',
      deleteProject_title: 'Delete Project',
      deleteTask: 'Delete task',
      deleteTask_title: 'Delete Task',
      deleteUser: 'Delete user',
      duplicate: 'Duplicate',
      duplicateCard_title: 'Duplicate Card',
      edit: 'Edit',
      editColor_title: 'Edit Color',
      editDueDate_title: 'Edit Due Date',
      editDescription_title: 'Edit Description',
      editEmail_title: 'Edit E-mail',
      editInformation_title: 'Edit Information',
      editPassword_title: 'Edit Password',
      editPermissions: 'Edit permissions',
      editStopwatch_title: 'Edit Stopwatch',
      editTitle_title: 'Edit Title',
      editUsername_title: 'Edit Username',
      giveFeedback_title: 'Give feedback',
      hideActivities: 'Hide activities',
      hideDetails: 'Hide details',
      exportCsv: 'Export as CSV',
      exportCsvColumn_assignees: 'Assignees',
      exportCsvColumn_completed: 'Completed',
      exportCsvColumn_completed_no: 'No',
      exportCsvColumn_completed_yes: 'Yes',
      exportCsvColumn_description: 'Description',
      exportCsvColumn_dueDate: 'Due date',
      exportCsvColumn_labels: 'Labels',
      exportCsvColumn_list: 'List',
      exportCsvColumn_name: 'Name',
      exportCsvColumn_tasks: 'Tasks',
      import: 'Import',
      leaveBoard: 'Leave board',
      leaveProject: 'Leave project',
      logOut_title: 'Log Out',
      makeCover_title: 'Make Cover',
      markAllAsRead: 'Mark all as read',
      move: 'Move',
      moveCard_title: 'Move Card',
      newBoard: 'New board',
      newCard: 'New card',
      remove: 'Remove',
      removeBackground: 'Remove background',
      removeColor: 'Remove color',
      removeCover_title: 'Remove Cover',
      removeFromBoard: 'Remove from board',
      removeFromProject: 'Remove from project',
      removeManager: 'Remove manager',
      removeMember: 'Remove member',
      rename: 'Rename',
      save: 'Save',
      selectFile: '<0>Drag and drop</0> or <1></1><2>click here to select file</2>',
      selectProject: 'Select project',
      share: 'Share',
      showActivities: 'Show activities',
      showAllAttachments: 'Show all attachments ({{hidden}} hidden)',
      showDetails: 'Show details',
      showFewerAttachments: 'Show fewer attachments',
      sortList_title: 'Sort List',
      start: 'Start',
      stop: 'Stop',
      submit: 'Submit',
      subscribe: 'Subscribe',
      unsubscribe: 'Unsubscribe',
      uploadNewAvatar: 'Upload new avatar',
      uploadNewImage: 'Upload new image',
    },
    feedback_widget: {
      shortTitle: 'Feedback?',
      title: 'Do you have any feedback?',
      placeholder: 'Share your feedback here...',
      email_placeholder: 'Your email...',
      submit_text: 'Send Feedback',
      success_text: 'Thank you for your feedback!',
      success_text2: "In case of questions, we'll get back to you soon.",
    },
  },
};
